import './loading-spinner.scss'

const LoadingSpinner = () => {
  return <div className="loading-spinner"></div>
}

export default LoadingSpinner
